module.exports = __webpack_public_path__ + "img/11.4fec16f0.webp";